import type { ReactElement } from 'react';
import { useState } from 'react';

import { Component as InfoIcon } from 'icons/icon-circle--info.svg';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function RetailDeliveryFeeTooltip(): ReactElement {
  const [show, setShow] = useState(false);

  const showTooltip = () => {
    setShow(true);
  };
  const hideTooltip = () => {
    setShow(false);
  };

  return (
    <OverlayTrigger
      placement="top"
      show={show}
      overlay={(
        <Tooltip
          id="retail-delivery-fee-tooltip"
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
        >
          Colorado requires us to collect this fee for all orders containing
          sales tax and being delivered to the state of Colorado.&nbsp;
          <a
            href="https://tax.colorado.gov/retail-delivery-fee"
            rel="noreferrer"
            target="_blank"
          >
            Read more
          </a>
        </Tooltip>
      )}
    >
      <span
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        <InfoIcon
          height="21"
          width="21"
          className="c-svg-fill-gray-068-color"
        />
      </span>
    </OverlayTrigger>
  );
}

export default RetailDeliveryFeeTooltip;
